<script>
export default {
  name: "ConfirmationModal",
  components: {},
  props: {
    title: String,
    message: String,
    variant: String,
    disabled: Boolean,
    buttonText: String,
    buttonClass: {
      type: String,
      default: "ml-2",
    },
    size: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.showModal = false;
      this.$emit("onClose");
      this.$emit("closed");
    },
    ok() {
      this.$emit("onSubmit");
      this.close();
    },
  },
};
</script>

<template>
  <span>
    <b-button
      :disabled="disabled"
      :class="buttonClass"
      :size="size"
      @click="showModal = true"
      :variant="variant"
      >{{ this.buttonText }}</b-button
    >
    <b-modal
      @hidden="close"
      v-model="showModal"
      :title="title"
      size="md"
      centered
      hide-footer
    >
      <div class="">
        <div class="row mb-3">
          <div class="col-12">
            {{ this.message }}
          </div>
        </div>
      </div>

      <div class="form-group text-right mt-3">
        <div class="row align-items-middle justify-content-middle">
          <div class="col-12">
            <button class="btn btn-outline-secondary px-4 mr-2" @click="close">
              Otkaži
            </button>
            <b-button @click="ok" variant="primary" class="btn px-4 ml-2"
              >Ok</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<style scoped>
.price-item {
  background-color: #fbfbfb;
  box-shadow: 0px 0px 0px #ffffff;
  border-radius: 4px;
}

.tab-section {
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 0px;
  margin-top: 0px;
}

.tab-section:last-child {
  border: 0px;
}

.price-container {
  width: 170px;
}

.sum-section {
  margin-right: 5px;
  border-top: 2px solid #f6f6f6;
  padding-top: 10px;
}

.total-price {
  position: relative;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.pricing-header-row {
  border-bottom: 2px solid #f6f6f6;
  border-radius: 2px;
}

.social-image-container {
  height: 30px;
}

.autocomplete {
  width: 100%;
}
</style>
